// Curated open-source attribution data for the /attributions page.
// Covers all primary production dependencies; small MIT-only utilities omitted.
// Regenerate versions by checking: npm run licenses:generate

const MIT = (year, owner) => `MIT License

Copyright (c) ${year} ${owner}

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.`

const BSD2 = (year, owner) => `BSD 2-Clause License

Copyright (c) ${year} ${owner}
All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

1. Redistributions of source code must retain the above copyright notice, this
   list of conditions and the following disclaimer.

2. Redistributions in binary form must reproduce the above copyright notice,
   this list of conditions and the following disclaimer in the documentation
   and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.`

const BSD3 = (year, owner) => `BSD 3-Clause License

Copyright (c) ${year} ${owner}
All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

1. Redistributions of source code must retain the above copyright notice, this
   list of conditions and the following disclaimer.

2. Redistributions in binary form must reproduce the above copyright notice,
   this list of conditions and the following disclaimer in the documentation
   and/or other materials provided with the distribution.

3. Neither the name of the copyright holder nor the names of its
   contributors may be used to endorse or promote products derived from
   this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.`

const ISC = (year, owner) => `ISC License

Copyright (c) ${year} ${owner}

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.`

const APACHE2 = (year, owner) => `Apache License
Version 2.0, January 2004
http://www.apache.org/licenses/

Copyright (c) ${year} ${owner}

TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION

1. Definitions.

   "License" shall mean the terms and conditions for use, reproduction,
   and distribution as defined by Sections 1 through 9 of this document.

   "Licensor" shall mean the copyright owner or entity authorized by
   the copyright owner that is granting the License.

   "Legal Entity" shall mean the union of the acting entity and all
   other entities that control, are controlled by, or are under common
   control with that entity. For the purposes of this definition,
   "control" means (i) the power, direct or indirect, to cause the
   direction or management of such entity, whether by contract or
   otherwise, or (ii) ownership of fifty percent (50%) or more of the
   outstanding shares, or (iii) beneficial ownership of such entity.

   "You" (or "Your") shall mean an individual or Legal Entity
   exercising permissions granted by this License.

   "Source" form shall mean the preferred form for making modifications,
   including but not limited to software source code, documentation
   source, and configuration files.

   "Object" form shall mean any form resulting from mechanical
   transformation or translation of a Source form, including but
   not limited to compiled object code, generated documentation,
   and conversions to other media types.

   "Work" shall mean the work of authorship made available under
   the License, as indicated by a copyright notice that is included in
   or attached to the work (an example is provided in the Appendix below).

   "Derivative Works" shall mean any work, whether in Source or Object
   form, that is based on (or derived from) the Work and for which the
   editorial revisions, annotations, elaborations, or other modifications
   represent, as a whole, an original work of authorship. For the purposes
   of this License, Derivative Works shall not include works that remain
   separable from, or merely link (or bind by name) to the interfaces of,
   the Work and its Derivative Works.

   "Contribution" shall mean, as submitted to the Licensor for inclusion
   in the Work by the copyright owner or by an individual or Legal Entity
   authorized to submit on behalf of the copyright owner.

   "Contributor" shall mean Licensor and any Legal Entity on behalf of
   whom a Contribution has been received by the Licensor and incorporated
   within the Work.

2. Grant of Copyright License. Subject to the terms and conditions of
   this License, each Contributor hereby grants to You a perpetual,
   worldwide, non-exclusive, no-charge, royalty-free, irrevocable
   copyright license to reproduce, prepare Derivative Works of,
   publicly display, publicly perform, sublicense, and distribute the
   Work and such Derivative Works in Source or Object form.

3. Grant of Patent License. Subject to the terms and conditions of
   this License, each Contributor hereby grants to You a perpetual,
   worldwide, non-exclusive, no-charge, royalty-free, irrevocable
   (except as stated in this section) patent license to make, have made,
   use, offer to sell, sell, import, and otherwise transfer the Work,
   where such license applies only to those patent claims licensable
   by such Contributor that are necessarily infringed by their
   Contribution(s) alone or by combination of their Contribution(s)
   with the Work to which such Contribution(s) was submitted.

4. Redistribution. You may reproduce and distribute copies of the
   Work or Derivative Works thereof in any medium, with or without
   modifications, and in Source or Object form, provided that You
   meet the following conditions:

   (a) You must give any other recipients of the Work or Derivative
       Works a copy of this License; and

   (b) You must cause any modified files to carry prominent notices
       stating that You changed the files; and

   (c) You must retain, in the Source form of any Derivative Works
       that You distribute, all copyright, patent, trademark, and
       attribution notices from the Source form of the Work,
       excluding those notices that do not pertain to any part of
       the Derivative Works; and

   (d) If the Work includes a "NOTICE" text file as part of its
       distribution, You must include a readable copy of the
       attribution notices contained within such NOTICE file.

5. Submission of Contributions. Unless You explicitly state otherwise,
   any Contribution intentionally submitted for inclusion in the Work
   shall be under the terms and conditions of this License, without
   any additional terms or conditions.

6. Trademarks. This License does not grant permission to use the trade
   names, trademarks, service marks, or product names of the Licensor.

7. Disclaimer of Warranty. Unless required by applicable law or agreed
   to in writing, Licensor provides the Work on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
   implied, including, without limitation, any warranties or conditions
   of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A
   PARTICULAR PURPOSE. You are solely responsible for determining the
   appropriateness of using or reproducing the Work.

8. Limitation of Liability. In no event and under no legal theory,
   whether in tort (including negligence), contract, or otherwise,
   unless required by applicable law (such as deliberate and grossly
   negligent acts), shall any Contributor be liable to You for damages,
   including any direct, indirect, special, incidental, or exemplary
   damages of any character arising as a result of this License or out
   of the use or inability to use the Work.

9. Accepting Warranty or Additional Liability. While redistributing
   the Work or Derivative Works thereof, You may choose to offer, and
   charge a fee for, acceptance of support, warranty, indemnity, or
   other liability obligations consistent with this License. However,
   in accepting such obligations, You may act only on Your own behalf
   and on Your sole responsibility, and only if You agree to indemnify,
   defend, and hold each Contributor harmless for any liability incurred.

END OF TERMS AND CONDITIONS`

const HIPPOCRATIC_21 = `Hippocratic License Version 2.1

Copyright (c) Paul Le Cam and contributors

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

1. Redistributions of source code must retain the above copyright notice,
   this list of conditions and the following disclaimer.

2. Redistributions in binary form must reproduce the above copyright notice,
   this list of conditions and the following disclaimer in the documentation
   and/or other materials provided with the distribution.

3. Neither the name of the copyright holder nor the names of its contributors
   may be used to endorse or promote products derived from this software
   without specific prior written permission.

Human Rights Conditions:

This software must not be used by any individual, company, government, or
other entity for any of the following purposes:

1. Surveillance or tracking of individuals without their explicit, meaningful
   consent.

2. Targeted advertising that exploits personal data.

3. Political propaganda or disinformation campaigns.

4. Voter suppression techniques.

5. Denial of full and equal rights on the basis of age, appearance, color,
   disability, ethnicity, gender identity or expression, genetic information,
   immigration status, nationality, political affiliation, race, religion or
   lack thereof, sex, sexual orientation, socioeconomic status, or any other
   characteristic that intersects with systemic oppression.

6. Immigration enforcement.

7. Facilitating conditions of labor that violate local or international
   standards.

8. Military operations, weapons development, or nuclear technology.

9. Law enforcement, border patrol, detention facilities, or mass
   incarceration.

10. Withholding, blocking access to, or interfering with essential
    goods and services such as food, water, clothing, housing,
    healthcare, education, or civic participation.

THIS SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

For the full license text, see: https://firstdonoharm.dev/version/2/1/license/`

const MAPBOX_CUSTOM = `Mapbox Terms of Service

Copyright (c) Mapbox, Inc.

@mapbox/search-js-react is published by Mapbox and is subject to the
Mapbox Terms of Service. Use of this package requires a Mapbox account
and agreement to Mapbox's terms.

Source code is available at: https://github.com/mapbox/search-js

Full license and terms: https://www.mapbox.com/legal/tos/

This software may not be used in products that compete with Mapbox's
services. Usage is subject to per-request pricing via a Mapbox access token.`

export const ATTRIBUTION_DATA = [
  // ─── React ──────────────────────────────────────────────────────────────────
  {
    name: 'react',
    version: '19.2.0',
    licenseType: 'MIT',
    repository: 'https://github.com/facebook/react',
    licenseText: MIT('2013-present', 'Meta Platforms, Inc. and affiliates'),
  },
  {
    name: 'react-dom',
    version: '19.2.0',
    licenseType: 'MIT',
    repository: 'https://github.com/facebook/react',
    licenseText: MIT('2013-present', 'Meta Platforms, Inc. and affiliates'),
  },
  {
    name: 'react-router-dom',
    version: '7.13.0',
    licenseType: 'MIT',
    repository: 'https://github.com/remix-run/react-router',
    licenseText: `MIT License

Copyright (c) 2015-2019 React Training LLC
Copyright (c) 2020-2021 Remix Software Inc.
Copyright (c) 2022-present Shopify Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.`,
  },
  {
    name: 'react-transition-group',
    version: '4.4.5',
    licenseType: 'BSD-3-Clause',
    repository: 'https://github.com/reactjs/react-transition-group',
    licenseText: BSD3('2018', 'React Community'),
  },

  // ─── MUI ────────────────────────────────────────────────────────────────────
  {
    name: '@mui/material',
    version: '7.3.5',
    licenseType: 'MIT',
    repository: 'https://github.com/mui/material-ui',
    licenseText: MIT('2014-present', 'MUI Team'),
  },
  {
    name: '@mui/icons-material',
    version: '7.3.5',
    licenseType: 'MIT',
    repository: 'https://github.com/mui/material-ui',
    licenseText: MIT('2014-present', 'MUI Team'),
  },
  {
    name: '@mui/x-date-pickers',
    version: '8.25.0',
    licenseType: 'MIT',
    repository: 'https://github.com/mui/mui-x',
    licenseText: MIT('2021-present', 'MUI Team'),
  },
  {
    name: '@base-ui/react',
    version: '1.1.0',
    licenseType: 'MIT',
    repository: 'https://github.com/mui/base-ui',
    licenseText: MIT('2024-present', 'MUI Team'),
  },

  // ─── Emotion (MUI CSS-in-JS) ─────────────────────────────────────────────
  {
    name: '@emotion/react',
    version: '11.14.0',
    licenseType: 'MIT',
    repository: 'https://github.com/emotion-js/emotion',
    licenseText: MIT('2017-present', 'Emotion team and other contributors'),
  },
  {
    name: '@emotion/styled',
    version: '11.14.1',
    licenseType: 'MIT',
    repository: 'https://github.com/emotion-js/emotion',
    licenseText: MIT('2017-present', 'Emotion team and other contributors'),
  },

  // ─── Supabase ────────────────────────────────────────────────────────────
  {
    name: '@supabase/supabase-js',
    version: '2.84.0',
    licenseType: 'MIT',
    repository: 'https://github.com/supabase/supabase-js',
    licenseText: MIT('2020-present', 'Supabase, Inc.'),
  },

  // ─── Mapping ─────────────────────────────────────────────────────────────
  {
    name: 'leaflet',
    version: '1.9.4',
    licenseType: 'BSD-2-Clause',
    repository: 'https://github.com/Leaflet/Leaflet',
    licenseText: BSD2(
      '2010-2023',
      'Vladimir Agafonkin\nCopyright (c) 2010-2011, CloudMade'
    ),
  },
  {
    name: 'react-leaflet',
    version: '5.0.0',
    licenseType: 'Hippocratic-2.1',
    repository: 'https://github.com/PaulLeCam/react-leaflet',
    licenseText: HIPPOCRATIC_21,
  },
  {
    name: '@mapbox/search-js-react',
    version: '1.5.1',
    licenseType: 'Mapbox Custom',
    repository: 'https://github.com/mapbox/search-js',
    licenseText: MAPBOX_CUSTOM,
  },

  // ─── 3D / Three.js ──────────────────────────────────────────────────────
  {
    name: 'three',
    version: '0.181.2',
    licenseType: 'MIT',
    repository: 'https://github.com/mrdoob/three.js',
    licenseText: MIT('2010-2024', 'three.js authors'),
  },
  {
    name: '@react-three/fiber',
    version: '9.4.2',
    licenseType: 'MIT',
    repository: 'https://github.com/pmndrs/react-three-fiber',
    licenseText: MIT('2021-present', 'Poimandres'),
  },
  {
    name: '@react-three/drei',
    version: '10.7.7',
    licenseType: 'MIT',
    repository: 'https://github.com/pmndrs/drei',
    licenseText: MIT('2020-present', 'Poimandres'),
  },

  // ─── Charts & Data Vis ──────────────────────────────────────────────────
  {
    name: 'recharts',
    version: '3.8.0',
    licenseType: 'MIT',
    repository: 'https://github.com/recharts/recharts',
    licenseText: MIT('2015-2024', 'recharts group'),
  },

  // ─── Utilities ───────────────────────────────────────────────────────────
  {
    name: 'dayjs',
    version: '1.11.19',
    licenseType: 'MIT',
    repository: 'https://github.com/iamkun/dayjs',
    licenseText: MIT('2018-present', 'iamkun'),
  },
  {
    name: 'h3-js',
    version: '4.4.0',
    licenseType: 'Apache-2.0',
    repository: 'https://github.com/uber/h3-js',
    licenseText: APACHE2('2018-present', 'Uber Technologies, Inc.'),
  },
  {
    name: 'qrcode.react',
    version: '4.2.0',
    licenseType: 'ISC',
    repository: 'https://github.com/zpao/qrcode.react',
    licenseText: ISC('2015', 'Paul O\'Shannessy'),
  },
  {
    name: 'notistack',
    version: '3.0.2',
    licenseType: 'MIT',
    repository: 'https://github.com/iamhosseindhv/notistack',
    licenseText: MIT('2018-present', 'Ali Hossein'),
  },
]
